import React, { useState } from "react";

import { useForm } from "react-hook-form";
import { postVitals, updateVitals } from "../../lib/api";
import { Spinner } from "../../shared/svgIcon";
import { dateConvert } from "../../shared/utils";

const VitalForm4 = (props) => {
  const { nextStep } = props;
  const [isLoading, setLoader] = useState(false)
  const [isSkip, setIsSkip] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const updateVitalInfo = async (payload) => {
    try {
      setLoader(true)
      const res = await postVitals(payload);
      // console.log(res, "vit");
      setLoader(false)
      nextStep();
    } catch (error) {
      setLoader(false)
      console.log(error);
    }
  };

  const onSubmit = (data) => {
    const user_id = localStorage.getItem("patientId");

    const form1 = sessionStorage.getItem("form1")
      ? JSON.parse(sessionStorage.getItem("form1"))
      : {};
    const form2 = sessionStorage.getItem("form2")
      ? JSON.parse(sessionStorage.getItem("form2"))
      : {};
    const form3 = sessionStorage.getItem("form3")
      ? JSON.parse(sessionStorage.getItem("form3"))
      : {};
    const mergedFormValues = {
      ...form1,
      ...form2,
      ...form3,
    };
    const payload = {
      consumer_id: user_id,
      source: {
        name: "",
        location: "",
        identifier: "654cc54350349ba664618567",
        classification: "mobile",
      },
      date: dateConvert(new Date()),
      data: {
        // age: null,
        height: {
          // value: null,
          unit: "cm",
        },
        weight: {
          // value: null,
          unit: "kg",
        },
        hr: {
          // value: null,
          unit: "bpm",
        },
        rr: {
          // value: null,
          unit: "bpm",
        },
        sbp: {
          // value: null,
          unit: "mmHg",
        },
        temperature: {
          // value: null,
          unit: "c",
        },
        dbp: {
          // value: null,
          unit: "mmHg",
        },
        glucose: {
          value: +data.glucose,
          unit: "mg/dL",
        },
        spo2: {
          value: +data.spo2,
          unit: "percentage",
        },
        ...mergedFormValues,
      },
    };
    // console.log(payload, "form", mergedFormValues,user_id);
    sessionStorage.removeItem("form1");
    sessionStorage.removeItem("form2");
    sessionStorage.removeItem("form3");
    sessionStorage.removeItem("currentVitals");
    if (user_id) updateVitalInfo(payload);
  };
  const onSkip = () => {
    const user_id = localStorage.getItem("patientId");
    if (
      sessionStorage.getItem("form1") ||
      sessionStorage.getItem("form2") ||
      sessionStorage.getItem("form3")
    ) {
      const form1 = sessionStorage.getItem("form1")
        ? JSON.parse(sessionStorage.getItem("form1"))
        : {};
      const form2 = sessionStorage.getItem("form2")
        ? JSON.parse(sessionStorage.getItem("form2"))
        : {};
      const form3 = sessionStorage.getItem("form3")
        ? JSON.parse(sessionStorage.getItem("form3"))
        : {};
      const mergedFormValues = {
        ...form1,
        ...form2,
        ...form3,
      };
      const payload = {
        consumer_id: user_id,
        source: {
          name: "",
          location: "",
          identifier: "654cc54350349ba664618567",
          classification: "mobile",
        },
        date: dateConvert(new Date()),
        data: {
          // age: null,
        height: {
          // value: null,
          unit: "cm",
        },
        weight: {
          // value: null,
          unit: "kg",
        },
        hr: {
          // value: null,
          unit: "bpm",
        },
        rr: {
          // value: null,
          unit: "bpm",
        },
        sbp: {
          // value: null,
          unit: "mmHg",
        },
        temperature: {
          // value: null,
          unit: "c",
        },
        dbp: {
          // value: null,
          unit: "mmHg",
        },
          glucose: {
            // value: null,
            unit: "mg/dL",
          },
          spo2: {
            // value: null,
            unit: "percentage",
          },
          ...mergedFormValues,
        },
      };
      // console.log(payload, "form", mergedFormValues);
      setIsSkip(true);
      if (user_id) updateVitalInfo(payload);
    }
    sessionStorage.removeItem("form1");
    sessionStorage.removeItem("form2");
    sessionStorage.removeItem("form3");
    sessionStorage.removeItem("currentVitals");
    nextStep();
  };
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="w-4/12 min-w-[200px]">
          <label
            htmlFor="glucose"
            className="text-black text-base font-medium font-['SF Pro Display'] pl-3 pb-2"
          >
            Glucose(mg/dL)
          </label>
          <input
            {...register("glucose", {
              required: true,
            })}
            id="glucose"
            name="glucose"
            type="number"
            step="0.001"
            autoComplete="off"
            autoCorrect="off"
            className=" bg-gray-200  flex h-9 w-full rounded-lg border border-input  px-3 py-1 text-base shadow-sm transition-colors   focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
          />
          {errors.glucose && (
            <p className="py-2 text-xs text-red-500">{"required"}</p>
          )}
        </div>
        <div className="flex flex-col sm:flex-row  my-2">
          <div className="w-full sm:w-4/12 min-w-[200px]">
            <label
              htmlFor="spo2"
              className="text-black text-base font-medium font-['SF Pro Display'] pl-3 pb-2"
            >
              SpO2(%)
            </label>
            <input
              {...register("spo2", {
                required: true,
                min: { value: 1, message: 'Spo2 must be at least 1' },
                max: { value: 100, message: 'Spo2 must be at most 100' },
              })}
              id="spo2"
              name="spo2"
              type="number"
              step="0.001"
              autoComplete="off"
              autoCorrect="off"
              className=" bg-gray-200  flex h-9 w-full rounded-lg border border-input  px-3 py-1 text-base shadow-sm transition-colors   focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
            />
            {errors.spo2 && (
              <p className="py-2 text-xs text-red-500">{"required"}</p>
            )}
          </div>
        </div>
        <div className="flex w-full gap-2 mt-8 sm:mt-10">
          <button
            className="bg-white rounded-[100px] border-2 border-blue-800 text-center flex shadow w-1/2"
            onClick={onSkip}
          >
            <div className="text-blue-800  font-semibold font-['SF Pro Display'] flex justify-center items-center   px-4 py-3 w-full">
            {isLoading && isSkip && <Spinner className="mr-2 h-4 w-4 animate-spin" />} Skip
            </div>
          </button>
          <button
            className="bg-blue-800 rounded-[100px] text-center flex shadow hover:bg-blue-800/90  w-1/2"
            type="submit"
          >
            <div className="text-white  font-semibold font-['SF Pro Display']  flex justify-center items-center   px-4 py-3 w-full">
            {isLoading && !isSkip && <Spinner className="mr-2 h-4 w-4 animate-spin" />} Next
            </div>
          </button>
        </div>
      </form>
    </div>
  );
};

export default VitalForm4;
